import { render, staticRenderFns } from "./carbon.vue?vue&type=template&id=b7cbd288&scoped=true&"
import script from "./carbon.vue?vue&type=script&lang=js&"
export * from "./carbon.vue?vue&type=script&lang=js&"
import style0 from "./carbon.vue?vue&type=style&index=0&id=b7cbd288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cbd288",
  null
  
)

export default component.exports